<template>
  <Modal title="订单发送货" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="deliveryInfo"  :model='deliveryInfo' label-position="right" :label-width="120" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="发货类型" prop="delivery_status">
            <RadioGroup v-model="deliveryInfo.delivery_status">
              <Radio :label="0" class="radio">未发货</Radio>
              <Radio :label="1">已发货</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="物流单号" prop="logistics_no"  v-if="deliveryInfo.delivery_status==1 || deliveryInfo.delivery_status==2">
            <Input placeholder="请输入" v-model="deliveryInfo.logistics_no"></Input>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('deliveryInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { deliveryInfo, changeFh } from '@/api/pointorder'
export default {
  name: 'orderEdit',
  props: ['editShow', 'id'],
  data () {
    return {
      isShow: false,
      order_id: 0,
      deliveryInfo: {
        order_id: 0,
        delivery_status: 0,
        logistics_no: ''
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
    },
    id (val) {
      this.order_id = val
      this.delivery()
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel', false)
    },
    handleOk (name) {
      if (this.deliveryInfo.delivery_status === 1 && (this.deliveryInfo.logistics_no === '' || this.deliveryInfo.logistics_no === null)) {
        this.$Message.error('物流单号必填')
        return
      }
      // console.log(this.deliveryInfo)
      // return
      this.$refs[name].validate(valid => {
        if (valid) {
          changeFh(this.deliveryInfo).then(res => {
            let msg = '发货成功'
            this.$Message.success(msg)
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          this.$emit('updateStatusModel', false)
        }
      })
    },
    delivery () {
      if (this.order_id) {
        let data = { 'order_id': this.order_id }
        deliveryInfo(data).then(res => {
          this.deliveryInfo = res.data
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    }
  }
}
</script>
